// extracted by mini-css-extract-plugin
export default {"melodyVideo":"zK-z","isFullWidth":"AK-z","landingPageVideo":"BK-z","play":"CK-z","iframeVideo":"DK-z","playHidden":"EK-z","fullwidth":"FK-z"};